import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

export default function AccountDeletedPage() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6" data-testid="account-deleted-page">
      <div className="max-w-md w-full bg-white rounded-2xl border border-[#E5E7EB] p-8 text-center">
        <CheckCircle2 className="w-12 h-12 text-[#4A7C59] mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-[#2C3E50] mb-3">Account eliminato</h1>
        <p className="text-[#64748B]">
          Il tuo account e tutti i suoi dati sono stati eliminati definitivamente.
        </p>
        <Link to="/" className="inline-block mt-6 text-[#4A7C59] font-medium" data-testid="account-deleted-home-link">
          Torna alla home
        </Link>
      </div>
    </div>
  );
}
